import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
${({ displayState }) => css`
  border: 1px solid #E3E3E3;
  border-radius: 20px;
  min-width: ${displayState?.minWidth ?? '60em'};
  padding: 15px 22px;
`}
`;

export default Wrapper(template)